module.exports = __webpack_public_path__ + "img/hubertus.c095b358.jpeg";